import React from 'react';

export const HallowComponent = class HallowComponent extends React.Component {
    // optional prop: usePublic:true to use the public APIs (no auth needed)
    state = {}
    baseUrl = (this.props.usePublic ? process.env.REACT_APP_API_URL + "public/" : process.env.REACT_APP_API_URL);
    token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOjEsIm5hbWUiOiJUZXN0IFVzZXIiLCJlbWFpbCI6InRlc3RAaGFsbG93LmFwcCIsInBlcm1pc3Npb25zIjpbMF0sImRldmljZSI6MTAsImV4cCI6MTYyNTk0Mjk3NCwiaWF0IjoxNjI1ODUyOTc0fQ.JnsXSo0r6MvKk3ht372a45wSNho6dkwGcOaqmAULQe0';
    parentKey = this.props.myKey;

    getAPI = async (getType, getId) => {
        let method;
        switch(getType) {
            case 'prayers':
            case 'audio':
            case 'content':
                method = 'GET';
                break;
            default:
                method = 'POST';
        }
        let options = {
            method: method,
            //mode: 'same-origin',
            header: {
                'Content-Type': 'application/json',
                'X-Hallow-Version': '840',
            }
        };
        if (!this.props.usePublic) {
            options.header.Authorization = 'Bearer ' + this.token;
        }
        return fetch(this.baseUrl + getType + '/' + (getId ? getId + '/' : ''), options).then(response => {
            if (response.ok) {
                return response.json();
            }
            throw response;
        });
    }

    generateKeyProps = (newElement) => {
        let child = this.generateChildKey(newElement);
        return { key: child, myKey: child };
    }

    generateChildKey = (newElement) => {
        return this.parentKey + '_' + newElement;
    }

    parseLinks = (text) => {
        let re = /(https?:\/\/.*?)(?=\s|$)/g;
        let rei = [...text.matchAll(re)];
        // always loop backwards so indices remain accurate
        for (let i = rei.length - 1; i >= 0; i--) {
            let link = rei[i][0];
            let idx = rei[i].index;
            let anchor = document.createElement('a');
            anchor.href = link;
            anchor.innerText = link;
            anchor.target = '_blank';
            text = text.slice(0, idx) + anchor.outerHTML + text.slice(idx + link.length);
        }
        return text;
    }
}

export default HallowComponent;